// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';
import { render } from './common';

/**
 * @class Jsw.ListContainer
 * @extends Jsw.Container
 */
export const ListContainer = Class.create(Container, {
    _tag: 'ul',

    _renderItem(item) {
        let renderTargetId = null;
        const isEmptyItem = Object.isArray(item) && !item.size();

        if (!isEmptyItem) {
            renderTargetId = `${this._id}-item-${item.getId()}`;
        }

        let cls = this._getConfigParam('itemClass', '');

        if (this._getConfigParam('renderLastItemClass', '') && this._items.last() === item) {
            cls = 'last';
        }

        if (isEmptyItem) {
            cls += ` ${this._getConfigParam('emptyItemClass', '')}`;
        }

        if (cls) {
            cls = ` class="${cls}"`;
        }

        $(this._contentAreaId).insert(`<li ${renderTargetId ? `id="${renderTargetId}"` : ''}${cls}></li>`);

        if (!isEmptyItem) {
            render($(renderTargetId), item);
        }
    },

});



// WEBPACK FOOTER //
// ./jsw/list-container.js